import { render, staticRenderFns } from "./CreateCompanyDialog.vue?vue&type=template&id=264e8ef6&scoped=true"
import script from "./CreateCompanyDialog.vue?vue&type=script&lang=js"
export * from "./CreateCompanyDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateCompanyDialog.vue?vue&type=style&index=0&id=264e8ef6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264e8ef6",
  null
  
)

export default component.exports